import { parseGiftPackPurchaseLimitType } from './giftPackPurchaseLimitType';

export type OrderCategoryId = 'vouchers' | 'diamond' | 'giftPacks';

const POSITION_CATEGORY_MAP: Record<string, OrderCategoryId> = {
  coupon: 'vouchers',
  voucher: 'vouchers',
  luxury: 'diamond',
  diamond: 'diamond',
  gift: 'giftPacks',
  giftpack: 'giftPacks',
  giftpacks: 'giftPacks',
};

const normalizePosition = (position: string): string =>
  position.trim().toLowerCase().replace(/[\s_-]+/g, '');

export const resolveOrderCategoryId = (
  position?: string,
  purchaseLimitType?: unknown
): OrderCategoryId => {
  if (parseGiftPackPurchaseLimitType(purchaseLimitType)) {
    return 'giftPacks';
  }

  if (!position) {
    return 'vouchers';
  }

  const normalizedPosition = normalizePosition(position);
  return POSITION_CATEGORY_MAP[normalizedPosition] || 'vouchers';
};
